var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g({staticClass:"shape-arrow",class:[_vm.data.class, _vm.data.staticClass]},_vm.listeners),[_vm._m(0)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"shape-arrow__body"},[_c('div',{staticClass:"shape-arrow__icon"})])}]

export { render, staticRenderFns }